export default "__VITE_ASSET__BonfG0fv__"